import { Link, Text } from 'platform-components';
import React from 'react';

import './assignment__send-link-control.scss';

interface Props {
    canEditTeam: boolean;
    onSendStudentLinkClick: () => void;
}

export const AssignmentSendLinkControl = React.memo((props: Props) => {
    const { canEditTeam, onSendStudentLinkClick } = props;

    if (!canEditTeam) {
        return null;
    }

    return (
        <Link mix="assignment__send-link-control" onClick={onSendStudentLinkClick} pseudo theme={Link.THEME.PRIMARY}>
            <Text id="assignLessonModal.sendStudentLink" weight={Text.WEIGHT.M} />
        </Link>
    );
});
